export default __webpack_public_path__ + "static/media/1300.8187b1de.jpeg";